var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-dashboard"},[_c('c-table',{key:'table-in-progress',staticClass:"o-dashboard__table-accounts",attrs:{"columns":_vm.columns,"placeholder":'Zoek op naam of E-mailadres',"endpoint":'/api/accounts/'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }